// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__-MwVo","signatureBlock":"Footer_signatureBlock__3dPMC","signature":"Footer_signature__13Gts"};